module.exports = __webpack_public_path__ + "img/bg.a0e1104a.jpg";